import { IAriyaMonitorData, IAriyaMonitorDataReportFormat } from "../../constants/interface/ariya";
import { postDataV2 } from "../utils";
import { apiPrefix, apiPrefix_Dp } from "./constants";

export const fetchVisitsData = (): Promise<IAriyaMonitorData> => postDataV2(`${apiPrefix_Dp}/ariya_visits`, {});
export const fetchHandraisersData = (): Promise<IAriyaMonitorData> => postDataV2(`${apiPrefix_Dp}/ariya_hand_raisers`, {});
export const fetchPreOrderData = (): Promise<IAriyaMonitorData> =>
  postDataV2(`${apiPrefix_Dp}/ariya_pre_order`, { market: ["Japan", "Norway"] });
export const fetchPreOrderDepositsData = (): Promise<IAriyaMonitorDataReportFormat> =>
  postDataV2(`${apiPrefix}/ariya_online_deposits_total`, {});
export const fetchPreOrderDepositsChartData = (): Promise<IAriyaMonitorDataReportFormat> =>
  postDataV2(`${apiPrefix}/ariya_online_deposits_total_last_4_weeks`, {});
